var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("body", [
      _c(
        "div",
        { staticClass: "voucher" },
        [
          _c("h1", { staticClass: "read-only" }, [
            _vm._v("SAVE THE TREES 교환권 페이지")
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", [
                _c("div", [
                  _c("h2", [
                    _c("span", [_vm._v(_vm._s(_vm.couponInfo.coupon_name))])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.couponInfo.coupon_type))])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("img", {
                  staticClass: "product",
                  attrs: { src: _vm.couponInfo.product_image, alt: "제품" }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getProductNameForEnter(_vm.couponInfo.product_name)
                    )
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("coupondetailvue", {
            attrs: {
              propCouponInfo: this.propCouponInfo,
              propCouponDetail: this.propCouponDetail,
              aboInfo: this.aboInfo,
              couponNo: this.couponNo
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "element" }, [
      _c("p", [
        _c("span", { staticClass: "read-only" }, [_vm._v("SAVE THE TREES")])
      ]),
      _vm._v(" "),
      _c("span", [
        _c("span", { staticClass: "read-only" }, [_vm._v("나무 이미지")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-683e5d83", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683e5d83","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/couponsys/savethetrees.vue
// module id = null
// module chunks = 